import { EventTitleEnum } from '../../common/enums/common.enum';

export const getEventItemsForCount = (eventName: EventTitleEnum, childEvents: any[], options: any[]) => {
  switch (eventName) {
    case EventTitleEnum.MEALS:
    case EventTitleEnum.ADDITIONAL_ACTIVITIES:
      return [...childEvents, ...options];
    case EventTitleEnum.TOILET:
      return [...childEvents];
    case EventTitleEnum.SLEEP:
    case EventTitleEnum.MAIN_ACTIVITY:
    case EventTitleEnum.CHILD_INTERACTION:
    case EventTitleEnum.OTHER_KIDS:
    case EventTitleEnum.MOOD:
      return [...options];

    default:
      return [...childEvents, options];
  }
};